import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

// 指令
import fadeIn from "./assets/directives/fadeIn";
import countUp from "./directives/countUp";
Vue.directive("fadeIn", fadeIn);
Vue.directive("count-up", countUp);

// ===== 最简单的 Element UI 引入 =====
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
Vue.use(ElementUI);

// ===== Swiper =====
import "swiper/css";
import "swiper/css/navigation"; // 加上这个！
import "swiper/css/pagination";

// 全局样式
import "@/assets/style/common.less";

// 限制缩放自定义
import 'amfe-flexible'

// 全局组件懒加载
Vue.component("LearnMoreBtn", () => import("@/components/LearnMoreBtn.vue"));
Vue.component("DetailBtn", () => import("@/components/detailBtn.vue"));

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
